import "./LateralMenuElement.css";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { Link, useLocation } from "react-router-dom";
import { BASE_URL } from "@/assets/constants/constants";
import { Icon } from "@/components/icons/Icon";
import type { IconName } from "@/components/icons/icons";

interface MenuElementProps {
  section: "inspections" | "checklist";
  index: number;
}

const icons = ["inspections", "cog"] as IconName[];

const LateralMenuElement = ({ section, index }: MenuElementProps) => {
  const location = useLocation();

  const realPath = location.pathname.replace(`${BASE_URL}`, "");

  const translate = useTranslate();

  const getRoute = () => {
    if (section === "inspections") return BASE_URL;
    return `${BASE_URL}/${section}`;
  };

  const isActive = () => {
    if (realPath === "" && section === "inspections") return true;
    return realPath.includes(section);
  };

  return (
    <div
      data-testid={`lateral-menu-${section}`}
      className={`lateral-menu-element${index === 0 ? " first-element" : ""}${
        isActive() ? " active-menu-element " : ""
      }`}
    >
      <Link to={getRoute()}>
        <button type="button">
          <Icon name={icons[index]} className="" />
          <p className="font-thin text-xs">{translate(section)}</p>
        </button>
      </Link>
    </div>
  );
};

export default LateralMenuElement;
